import { useState } from 'react';

import { IRentalTile } from '@/utility/mapSearchResultToTile';

import { QuickPreviewModal } from './QuickPreviewModal';

type TTriggerComponentProps = {
  toggleQuickPreview: () => void;
};

type TQuickPreviewModalWrapperProps = {
  rentalTile: IRentalTile;
  onClickViewListing?: () => void;
  TriggerComponent: (props: TTriggerComponentProps) => React.ReactNode;
};

export const QuickPreviewModalWrapper = ({
  rentalTile,
  onClickViewListing,
  TriggerComponent,
}: TQuickPreviewModalWrapperProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleQuickPreview = () => {
    setIsOpen(true);
  };

  return (
    <>
      <TriggerComponent toggleQuickPreview={toggleQuickPreview} />
      {isOpen && (
        <div className="hidden" onClick={e => e.stopPropagation()}>
          <QuickPreviewModal
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            rentalTile={rentalTile}
            onClickViewListing={onClickViewListing}
          />
        </div>
      )}
    </>
  );
};
